import { Route, Routes } from 'react-router-dom';

import CommonLayout from 'components/layout/CommonLayout';
import Match from './Match';
import Search from './Search';
import Rank from './Rank';

// login
import LoginLayout from 'components/layout/LoginLayout';
import Login from './login/login-main/Login';
import PasswordAssistance from './login/PasswordAssistance';
import PasswordReset from './login/PasswordReset';
import PasswordHelp from './login/PasswordHelp';

const PageRouter = () => {
	return (
		<>
			<Routes>
				<Route path="/imms">
					<Route element={<CommonLayout />}>
						<Route index element={<Rank />} />
						<Route path="rank" element={<Rank />} />
						<Route path="match" element={<Match />} />
						<Route path="search" element={<Search />} />
					</Route>
					<Route path="login" element={<Login />} />
					<Route path="login" element={<LoginLayout />}>
						<Route path="password_assistance" element={<PasswordAssistance />} />
						<Route path="password_help" element={<PasswordHelp />} />
						<Route path="password_reset/:uid/:token" element={<PasswordReset />} />
					</Route>
				</Route>
			</Routes>
		</>
	);
};

export default PageRouter;
